/* eslint-disable react/require-default-props */
/* eslint-disable no-alert */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Select from 'react-select';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import styles from '../select/select.module.scss';
import Modal from '../../../components/modal';
import Clickable from '../../../components/clickable/Clickable';
import closeIcon from '../../../icons/close.svg';
import CompleteForm from '../../../modules/forms/completeForm/CompleteForm';
import {
  handleCalculation,
  renderInfoForType,
  getInlineTableValueForKey
} from '../../../utils/helpers';

import {
  normalizePreviewValue,
  hasPreviewDisplayValue,
  getDs6PreviewColumns
} from '../../../utils/ds6Helpers';

import DataSourceInformation from '../../components/DataSourceInformation';
import FormDataSourceDetails from '../../../components/customFields/FormDataSourceDetails';
import moment from '../../../utils/moment';
import { actionClearForm, fetchDataSourceFormDetails } from '../../../modules/forms/redux/actions';


class DataSource extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serachModal: false,
      formCreateModal: false,
      formEntryAnswer: {},
      dataSourceValueState: [],
      ds3InlineViewMode: 'grid',
      isExceed: false,
      createFieldId: ''
    };
    const { isRequired, updateFieldErrors, answer } = this.props;
    if (
      isRequired
      && (answer === '' || answer === undefined || answer === null)
    ) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
    this.ignoreFields = [
      'multi_field', 'signature', 'attachments', 'map_location', 'ssi_field',
      'header', 'multi_level', 'page_break'
    ];
  }

  componentDidMount() {
    const { dataSourceValues } = this.props;
    const { dataSourceValueState } = this.state;
    if (dataSourceValues && dataSourceValues?.length > 0 && dataSourceValueState?.length === 0) {
      this.handleDataSource();
    }
  }

  componentDidUpdate(prevProps) {
    const { createAction, createdFormAnswer, answer, dataSourceValues, publishFormAction,
      fieldId
     } = this.props;
    const { dataSourceValueState } = this.state;
    let localFieldId = localStorage.getItem('fieldId');

    const becameSuccess = !prevProps.createAction?.success && createAction?.success;
    if (becameSuccess && localFieldId === fieldId) {
      if (createdFormAnswer && Object.keys(createdFormAnswer).length > 0) {
        this.handleEntry(createdFormAnswer);
      }
    }
    if ((publishFormAction?.success && prevProps.publishFormAction?.loading)
      || answer?.value !== prevProps.answer?.value) {
      this.handleClearEntry();
    }
    if (dataSourceValues && (dataSourceValues?.length > 0) && dataSourceValueState?.length === 0) {
      this.handleDataSource();
    }
  }

  getValueAndFormData = (value, newDataEntry) => {
      let formData = {
        detailId: newDataEntry?.id,
        detailKey: newDataEntry?.key,
        key: value,
        label: value,
        text: value,
        value
      };
      return formData;
  };

  getIgnoreFieldKey = (field = {}) => {
    const widgetType = typeof field?.widget === 'string' ? field?.widget : field?.widget?.type;
    return String(field?.type || widgetType || '').trim().toLowerCase();
  };

  // eslint-disable-next-line class-methods-use-this, react/sort-comp
  normalizeName = (name) => {
    if (typeof name === 'string') {
      return name;
    }
    if (name && typeof name === 'object') {
      return Object.values(name)?.join(', ');
    }
    return '';
  };

  buildDs3OptionValue = entry => (
    `${this.normalizeName(entry?.name)}${entry?.description ? ` - ${entry?.description}` : ''}`
  );

  buildDs3OptionValueTruncated = entry => (
    `${this.normalizeName(entry?.name)}${entry?.description ? ` - ${String(entry?.description).slice(0, 25)}` : ''}`
  );

 getFormDetailID = ({ formEntryAnswer, settings, answer }) => {
    if (formEntryAnswer?.key) return formEntryAnswer.key;
    if (settings?.enable_multi_select_for_this_data_source_field) return answer;
    return answer?.detailId;
  };

  getInlineTableDetailId = (answer, formEntryAnswer) => {
    const { settings, answer: currentAnswer } = this.props;
    const { formEntryAnswer: stateFormEntryAnswer } = this.state;
    return this.getFormDetailID({
      formEntryAnswer: formEntryAnswer ?? stateFormEntryAnswer,
      settings,
      answer: answer ?? currentAnswer
    });
  };

  setDs3InlineViewMode = (ds3InlineViewMode) => {
    this.setState({ ds3InlineViewMode });
  };

  getDataSourceFieldValue = (entry, fieldId) => {
    if (!entry || !fieldId) return '';
    return getInlineTableValueForKey(
      [entry, entry?.data, entry?.response, entry?.values, entry?.payload],
      fieldId
    );
  };

  // eslint-disable-next-line react/sort-comp
  renderDs6PreviewColumnValue = (column, rawValue, info, user) => {
    const rendered = renderInfoForType(
      column,
      rawValue,
      info,
      null, null, null, null, null, user
    );
    if (hasPreviewDisplayValue(rendered)) return rendered;
    return normalizePreviewValue(rawValue) || '-';
  };


   // eslint-disable-next-line class-methods-use-this
  shouldShowLinkedValuesInline = (props = this.props) => {
    const { dataSourceID, settings } = props;
    if (dataSourceID !== 'ds6') {
      return Boolean(settings?.show_values_in_inline_table_view);
    }

    return true;
  };

  handleSearchModal = () => {
    const { disableDataSourceActions } = this.props;
    if (disableDataSourceActions) return;

    this.setState({
      serachModal: true,
      formCreateModal: false,
      isExceed: false
    });
  };

  handleEntry = (newDataEntry) => {
    const { filters, answer, allFields } = this.props;
    const { formEntryAnswer, createFieldId } = this.state;
    let isMultiSelect = allFields?.find(all => all?.id === createFieldId);
    if (newDataEntry && Object.keys(newDataEntry).length>0) {
      if (isMultiSelect?.settings?.enable_multi_select_for_this_data_source_field) {
        let formData = [];
        let newFormEntryData = [];
        let value;
        if (Array.isArray(formEntryAnswer) && formEntryAnswer.length > 0) {
          newFormEntryData = [...formEntryAnswer, newDataEntry];
          newFormEntryData.forEach((newEntry) => {
            value = newEntry?.data?.[filters?.field_id];
            if (value != null) {
              let newFormData = this.getValueAndFormData(value, newEntry);
              formData.push(newFormData);
            }
          });
          this.setState({ formEntryAnswer: newFormEntryData, serachModal: false });
        } else {
            value = newDataEntry?.data[filters?.field_id];
            formData = [this.getValueAndFormData(value, newDataEntry)];
            this.setState({ formEntryAnswer: [newDataEntry], serachModal: false });
        }
          let answers = Array?.isArray(answer) && answer?.length > 0 ? [...answer?.map(i => i?.detailId), newDataEntry?.key] : [newDataEntry?.key];
          this.handleMultiAnswerChanged(answers, createFieldId, formData, 'formCreate', newDataEntry);
      } else {
        let value = newDataEntry?.data[filters?.field_id];
        let formData = this.getValueAndFormData(value, newDataEntry);
        this.setState({ formEntryAnswer: newDataEntry, serachModal: false });
        this.handleAnswerChanged(value, createFieldId, formData, newDataEntry);
      }
    }
  };

  handleDataSource = () => {
    const { dataSourceValues } = this.props;
    this.setState({ dataSourceValueState: dataSourceValues });
  };

  handleClearEntry = () => {
    const { settings } = this.props;
    if (!settings?.enable_multi_select_for_this_data_source_field) this.setState({ formEntryAnswer: {} });
  };

  handleCompleteFormModal = (boolean, type, id) => {
      const { answer, useCurrentStep, allFields, disableDataSourceActions } = this.props;
      if (disableDataSourceActions) return;

      let currentFieldData = allFields?.find(all => all?.id === id);
    if (currentFieldData?.settings?.enable_multi_select_for_this_data_source_field
          && currentFieldData?.settings?.restricted_count_for_multiSelect !== ''
          && currentFieldData?.settings?.restricted_count_for_multiSelect !== undefined
          && parseInt(currentFieldData?.settings?.restricted_count_for_multiSelect, 10) !== 0
          && Array.isArray(answer) && answer?.length >= parseInt(currentFieldData?.settings?.restricted_count_for_multiSelect, 10)
        ) {
          this.setState({ isExceed: true });
    } else {
      const { actionClearFetchedForm } = this.props;
      if (type === 'create') {
        localStorage.setItem('fieldId', id);
        localStorage.setItem('stepId', useCurrentStep?.id);
        actionClearFetchedForm();
        this.setState({ createFieldId: id, serachModal: boolean, formCreateModal: boolean, isExceed: false });
      } else if (type === 'clearCreate') {
        this.setState({ createFieldId: '', serachModal: boolean, formCreateModal: boolean, isExceed: false });
        localStorage.setItem('fieldId', '');
        localStorage.setItem('stepId', '');
      } else {
        actionClearFetchedForm();
        this.setState({ createFieldId: '', formCreateModal: boolean, isExceed: false });
      }
    }
  };


   handleCommonClick = (answer, entry, fieldId, settings) => {
    const isMulti = settings?.enable_multi_select_for_this_data_source_field;
    if (isMulti) {
      let ids = Array.isArray(answer) && answer?.length > 0
        ? [...answer.map(a => a?.detailId)]
        : [];
      const exists = ids.includes(entry?.key);
      const filteredData = exists
        ? ids.filter(id => id !== entry?.key)
        : [...ids, entry?.key];
      this.handleMultiAnswerChanged(filteredData, fieldId);
    } else {
      this.handleAnswerChanged(entry?.name, fieldId, {
        ...entry,
        detailKey: entry?.key
      });
    }
  };

  handleSelectChange = (e, fieldId, isMulti) => {
    if (isMulti) {
      this.handleMultiAnswerChanged(e?.map(i => i.value) ?? [], fieldId, e);
    } else {
      this.handleAnswerChanged(e?.value, fieldId, e);
    }
  };

  handleCalValues = async () => {
    const { fields, answers, fromMultiGrid, allFields, handleValueChange, multiFieldId, formEntryFields } = this.props;
    let result;
    if (fromMultiGrid) {
      result = await handleCalculation(fields, answers, fromMultiGrid, allFields, multiFieldId);
    } else {
      result = await handleCalculation(formEntryFields, answers);
    }
    await result.reduce(async (promise, val) => {
      await promise;
      if (!val?.id) return;
      handleValueChange(val?.value, val.id);
    }, Promise.resolve());
  };

  handleDependencyFields = () => {
    const { formEntryFields, fieldId, handleValueChange, handleFieldErrorChanged } = this.props;
    if (formEntryFields?.length > 0) {
      formEntryFields.forEach((field) => {
        if (field?.type === 'number'
          && field?.settings?.form_count
          && Object.values(field?.settings?.count_map_fields || {})?.filter(f => f?.id === fieldId)?.length > 0
        ) {
          handleValueChange(undefined, field?.id);
          handleFieldErrorChanged(field?.id, true);
        }
      });
    }
  };

  findSelectedDs3Entry = (dataSourceValueState, selectedKey, selectedKeyStr) => {
    if (!Array.isArray(dataSourceValueState)) return null;

    const normalizedKey = String(selectedKey ?? '').trim();
    const normalizedStr = String(selectedKeyStr ?? '').trim();

    let entry = dataSourceValueState.find(val => val?.key === selectedKey
      || String(val?.id) === normalizedKey
      || String(val?.detailId) === normalizedKey);

    if (entry) return entry;
    entry = dataSourceValueState.find(val => String(val?.name) === normalizedStr
      || String(val?.value) === normalizedStr);

    if (entry) return entry;
    return dataSourceValueState.find((val) => {
      const full = this.buildDs3OptionValue(val);
      const truncated = this.buildDs3OptionValueTruncated(val);
      return (
        full === normalizedStr
        || truncated === normalizedStr
        || (normalizedStr.includes(' - ') && String(val?.name) === normalizedStr.split(' - ')[0]));
    });
  };

  async handleAnswerChanged(value, fieldId, selected, formEntryAnswer) {
    const {
      handleValueChange,
      handleFieldErrorChanged,
      isRequired,
      values,
      updateFieldErrors,
      fields,
      widget: { type: widget },
      dataSourceID,
      allFields,
      formEntryFields,
      formTabFeilds,
      answers,
      fieldType
    } = this.props;

    const { serachModal, dataSourceValueState } = this.state;
    const allFormFields = allFields?.length > 0 ? allFields : (formTabFeilds || []);
    const mergedAllFields = allFormFields?.length > 0
      ? [...allFormFields, ...(formTabFeilds || []).filter(f => !allFormFields?.some(a => a.id === f.id))]
      : (formTabFeilds || []);

    if (dataSourceID === 'ds6') {
      const entryKey = selected?.detailKey || selected?.detailId || formEntryAnswer?.key || formEntryAnswer?.id;
      const fullEntry = dataSourceValueState?.find(e => (
        String(e?.key) === String(entryKey) || String(e?.id) === String(entryKey)
      ));
      let selectedEntry;
      if (formEntryAnswer?.data) {
        selectedEntry = formEntryAnswer;
      } else if (selected?.data) {
        selectedEntry = selected;
      } else {
        selectedEntry = fullEntry;
      }
      const selectedValuePayload = {
        value,
        detailId: entryKey,
        detailKey: entryKey,
        ...(selectedEntry && typeof selectedEntry === 'object'
          ? {
            entry_data: selectedEntry,
            entryData: selectedEntry
          }
          : {})
      };
      let matchingField = null;
      if (fields?.length>0 && formEntryAnswer && Object.keys(formEntryAnswer)?.length>0) {
        matchingField = fields.find(ele => ele?.filters?.id === formEntryAnswer?.form_parent);
      }
      // If a matching field is found, execute handleValueChange
      if (matchingField && Object.keys(matchingField)?.length>0) {
        const fieldIdValue = matchingField?.id;
        handleValueChange(selectedValuePayload, fieldIdValue);
      } else {
        handleValueChange(selectedValuePayload, fieldId);
      }
      const entryData = selectedEntry?.data || fullEntry?.data;
      if (entryData && Object.keys(entryData).length > 0) {
        const copyFields = mergedAllFields?.filter(f => f?.settings?.copyField
          && f?.settings?.selectedCopyField?.startsWith(`ds6_${fieldId}_field_`)) || [];
        let hasNumberField = false;
        let updatedAnswers = { ...(answers || {}) };
        copyFields.forEach((field) => {
          const actualFieldId = field?.settings?.selectedCopyField?.replace(`ds6_${fieldId}_field_`, '');
          const ans = entryData?.[actualFieldId];
          if (ans !== undefined) {
            handleValueChange(ans, field.id);
            handleFieldErrorChanged(field.id, !(ans && ans !== ''));
            updatedAnswers = { ...updatedAnswers, [field.id]: ans };
            if (field.type === 'number') {
              hasNumberField = true;
            }
          }
        });
        if (hasNumberField) {
          let result = handleCalculation(formEntryFields || formTabFeilds, updatedAnswers);
          result.reduce(async (promise, val) => {
            await promise;

            if (!val?.id) return;

            const fieldSchema = (formEntryFields || formTabFeilds)?.find(f => f.id === val.id);
            const decimalConfig = fieldSchema?.settings?.validations?.decimal_point;

            const allowedDecimals = typeof decimalConfig?.name === 'number'
              ? decimalConfig.name
              : null;

            let finalValue = val?.value;

            if (
              allowedDecimals !== null
              && finalValue !== ''
              && finalValue !== undefined
              && !Number.isNaN(Number(finalValue))
            ) {
              const valueStr = String(finalValue);

              if (valueStr.includes('.')) {
                const [intPart, decimalPart] = valueStr.split('.');

                finalValue = decimalPart !== undefined
                  ? `${intPart}.${decimalPart.slice(0, allowedDecimals)}`
                  : intPart;
              }
            }
            handleValueChange(finalValue, val.id);
          }, Promise.resolve());
        }
      }
      if (serachModal) {
        this.setState({ serachModal: false });
      }
    } else if (dataSourceID === 'ds11') {
      handleValueChange(
        { value, detailId: selected?.detailKey },
        fieldId
      );
    } else if (dataSourceID === 'ds12') {
      handleValueChange(
        { value, detailId: selected?.detailKey },
        fieldId
      );
    } else {
      handleValueChange(value, fieldId);
    }
    let updatedErrors = [];
    if (value === '' || value === undefined || value === null) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      let validOption = values && Object.keys(values).some(k => values[k].key === value);
      if (widget === 'multiSearch' || widget === 'singleSearch' || widget === 'dropdown' || widget === 'user_dropdown'
      || fieldType === 'user_dropdown') {
        validOption = true;
      }
      if (widget === 'portal_user') {
        validOption = values?.some(eachVal => value?.some(selectOption => selectOption.key === eachVal.key));
      }
      handleFieldErrorChanged(fieldId, !validOption);
      if (!validOption) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.select.invalid_option'
        ];
      }
    }
    this.handleDependencyFields();
    updateFieldErrors(updatedErrors);
    this.setState({ createFieldId: '' });
  }

  handleMultiAnswerChanged(value, fieldId, selected, type, formEntryAnswer) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, values, updateFieldErrors,
      widget: { type: widget },
      dataSourceID, fields, settings
    } = this.props;
    const { dataSourceValueState } = this.state;
    const restrictedCount = parseInt(settings?.restricted_count_for_multiSelect, 10);
    const hasRestrictedCount = settings?.restricted_count_for_multiSelect !== ''
      && settings?.restricted_count_for_multiSelect !== undefined
      && restrictedCount !== 0;
    if (hasRestrictedCount && Array.isArray(value) && value?.length > restrictedCount) {
      this.setState({ isExceed: true });
      return;
    }
    this.setState({ isExceed: false });

    if (dataSourceID === 'ds6') {
      let dropdownValues = dataSourceValueState?.length > 0 ? dataSourceValueState?.map(val => ({
        key: val?.name,
        value: val?.name,
        label: val?.name,
        text: val?.name,
        detailKey: val?.key,
        detailId: val?.id
      })) : [];
      let result = [];
      if (Array.isArray(selected) && selected?.length > 0 && type === 'formCreate') {
        result = [...dropdownValues, ...selected]?.filter(item => value?.includes(item?.detailKey));
      } else if (selected !== undefined) {
        result = selected;
      } else {
        result = dropdownValues?.filter(item => value?.includes(item?.detailKey));
      }
      let finalValues = result?.map(e => ({ value: e?.label, detailId: e?.detailKey }));
      let matchingField = null;
      if (fields?.length>0 && formEntryAnswer && Object.keys(formEntryAnswer)?.length>0) {
        matchingField = fields.find(ele => ele?.filters?.id === formEntryAnswer?.form_parent);
      }
      // If a matching field is found, execute handleValueChange
      if (matchingField && Object.keys(matchingField)?.length>0) {
        const fieldIdValue = matchingField.id;
        handleValueChange(finalValues, fieldIdValue);
      } else {
        handleValueChange(
          finalValues,
          fieldId
        );
      }
    }
    let updatedErrors = [];
    if ((Array.isArray(value) && value?.length === 0) || value === undefined) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    } else {
      let validOption = value?.every(ele => Object.keys(
          values
        )?.some(
          k => (values[k]?.value === ele)
        ));
        if (widget === 'multiSearch' || widget === 'singleSearch') {
            validOption = true;
        }
      handleFieldErrorChanged(fieldId, !validOption);
      if (!validOption) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.select.invalid_option'
        ];
      }
    }
    updateFieldErrors(updatedErrors);
    this.setState({ createFieldId: '' });
  }


  render() {
    const {
      widget: { type: widget },
      fieldId,
      answer,
      values,
      defaultOption,
      dropdownMovesWithField,
      StylesClasses,
      placeholder,
      disabled,
      dataSourceID,
      filters,
      fields,
      source_fields,
      settings,
      createdFormAnswer,
      useCurrentStep,
      newStyles,
      showFieldErrors,
      isRequired,
      formDetail,
      edit,
      forFormModule,
      isInspection,
      allDataSources,
      disableDataSourceActions,
      fullWidth,
      user,
      fromMultiGrid,
      handleValueChange,
      isHideCompanyName,
      selected_users,
      fieldType
    } = this.props;
    const {
      serachModal,
      formCreateModal,
      formEntryAnswer,
      dataSourceValueState,
      isExceed,
      createFieldId
    } = this.state;
    let selectedValue = answer;
    const notamsField = fields?.length >0 ? fields.find(field => field.dataSourceID === 'ds7') : [];
    let dropdownValues = values;
    if (dataSourceID === 'ds6') {
      dropdownValues = dataSourceValueState?.length > 0
  ? dataSourceValueState.map((val) => {
      const displayName = this.normalizeName(val?.name);
      return {
        key: displayName,
        value: displayName,
        label: displayName,
        text: displayName,
        detailKey: val?.key,
        detailId: val?.id
      };
    })
  : [];
      if (settings?.enable_multi_select_for_this_data_source_field) {
        if (Array.isArray(formEntryAnswer) && formEntryAnswer.length > 0) {
          let formData = [];
          let value;
          let newFormEntryData = [...formEntryAnswer];
          newFormEntryData.forEach((newEntry) => {
            value = newEntry?.data?.[filters?.field_id];
            if (value != null) {
              let newFormData = this.getValueAndFormData(value, newEntry);
              formData.push(newFormData);
            }
          });
          dropdownValues = [...dropdownValues, ...formData];
        } else if (createdFormAnswer && Object.keys(createdFormAnswer)?.length > 0) {
          let value = createdFormAnswer?.data[filters?.field_id];
          let formData = this.getValueAndFormData(value, createdFormAnswer);
          dropdownValues = [...dropdownValues, formData];
        }
        selectedValue = dropdownValues
                        ?.filter(e => answer && Array.isArray(answer) && answer?.some(a => e?.detailKey === a?.detailId))
                        ?.map(ele => ({
                          key: ele?.detailKey,
                          label: ele?.label,
                          value: ele?.label,
                          detailKey: ele?.detailKey,
                          detailId: ele?.id
                        }));
      } else {
        if (formEntryAnswer && Object.keys(formEntryAnswer).length > 0 && !Array.isArray(formEntryAnswer)) {
          let value = formEntryAnswer?.data?.[filters?.field_id] ?? formEntryAnswer?.name;
          let formData = this.getValueAndFormData(value, formEntryAnswer);
          if (!dropdownValues.some(d => String(d.detailKey) === String(formData.detailKey))) {
            dropdownValues = [...dropdownValues, formData];
          }
        } else if (createdFormAnswer && Object.keys(createdFormAnswer)?.length > 0) {
          let value = createdFormAnswer?.data?.[filters?.field_id] ?? createdFormAnswer?.name;
          let formData = this.getValueAndFormData(value, createdFormAnswer);
          if (!dropdownValues.some(d => String(d.detailKey) === String(formData.detailKey))) {
            dropdownValues = [...dropdownValues, formData];
          }
        }
        const rawVal = (createFieldId === fieldId || localStorage.getItem('fieldId') === fieldId)
          && (formEntryAnswer && Object.keys(formEntryAnswer)?.length > 0)
          ? formEntryAnswer?.data?.[filters?.field_id] ?? formEntryAnswer?.name : answer?.value;
        selectedValue = rawVal ? { label: rawVal, value: rawVal } : null;
      }
    } else if (dataSourceID === 'ds11') {
      dropdownValues = dataSourceValueState?.sort((a, b) => (a.badge_no || '')?.localeCompare(b.badge_no || ''))?.map(val => ({
        key: val?.order_number,
        value: val?.badge_no,
        label: val?.badge_no,
        text: val?.badge_no,
        detailKey: val?.order_number,
        detailId: val?.order_number
      }));
      selectedValue = answer?.value;
    } else if (dataSourceID === 'ds12') {
      dropdownValues = dataSourceValueState?.sort((a, b) => (a.avp_no || '')?.localeCompare(b.avp_no || ''))?.map(val => ({
        key: val?.order_number,
        value: val?.avp_no,
        label: val?.avp_no,
        text: val?.avp_no,
        detailKey: val?.order_number,
        detailId: val?.order_number
      }));
      selectedValue = answer?.value;
    } else if (dataSourceID === 'ds9') {
      dropdownValues = dataSourceValueState?.length > 0 ? dataSourceValueState?.map((e, idx) => ({
        value: e,
        key: idx,
        label: e
      })) : [];
    } else if (dataSourceID === 'ds7') {
      dropdownValues = dropdownValues?.length > 0 ? dropdownValues.map((e, idx) => ({
        value: notamsField?.full_width === false ? `${e.value.slice(0, 34)}` : `${e.value.slice(0, 100)}`,
        key: idx,
        label: notamsField?.full_width === false ? `${e.value.slice(0, 34)}` : `${e.value.slice(0, 100)}`,
        text: e.text
      }))
      : [];
    }
    const selectedTableViewColumnConfigs = dataSourceID === 'ds6'
      ? getDs6PreviewColumns(this.props)
      : (settings?.table_view_columns_to_display || []);
    const selectedTableViewColumns = selectedTableViewColumnConfigs
      ?.map(column => column?.value || column?.id || column?.key)
      ?.filter(Boolean);
    const hasSelectedTableViewColumns = selectedTableViewColumns?.length > 0;
    const showLinkedValuesInline = this.shouldShowLinkedValuesInline();
    const DEFAULT_FORM_NUMBER_COLUMN = '__form_number__';
    const DEFAULT_CREATED_DATE_COLUMN = '__created_date__';
    const normalizeIdentity = value => String(value || '').trim().toLowerCase();
    const currentLinkedFormKey = normalizeIdentity(filters?.form_key || filters?.key);
    const ds6Forms = allDataSources?.find(source => source?.name === 'ds6')?.forms || [];
    const selectedLinkedForm = ds6Forms?.find((formOption) => {
      const formKey = normalizeIdentity(formOption?.form_key || formOption?.form?.form_key);
      return formKey && formKey === currentLinkedFormKey;
    }) || {};
    const selectedLinkedFormSchemaFields = Array.isArray(selectedLinkedForm?.form?.schema?.fields)
      ? selectedLinkedForm?.form?.schema?.fields
      : [];
    const getDs6EntrySchema = entry => (
      entry?.form_version__schema
      || entry?.form_version?.schema
      || entry?.form_parent?.schema
      || entry?.schema
      || null
    );
    const ds6TableViewFieldsMap = new Map();
    (selectedLinkedFormSchemaFields || []).forEach((field) => {
      if (!field?.id || this.ignoreFields?.includes(this.getIgnoreFieldKey(field))) return;
      ds6TableViewFieldsMap.set(field?.id, field);
    });
    const ds6TableViewFields = Array.from(ds6TableViewFieldsMap.values());
    const selectedTableViewColumnsMap = new Map(
      selectedTableViewColumnConfigs?.map(column => [column?.value || column?.id || column?.key, column]) || []
    );
    let ds6OrderedTableColumns = [];
    if (ds6TableViewFields?.length > 0) {
      if (hasSelectedTableViewColumns) {
        ds6OrderedTableColumns = selectedTableViewColumns
          ?.map((columnId) => {
            if (columnId === DEFAULT_FORM_NUMBER_COLUMN) {
              return { id: DEFAULT_FORM_NUMBER_COLUMN, type: 'default' };
            }
            if (columnId === DEFAULT_CREATED_DATE_COLUMN) {
              return { id: DEFAULT_CREATED_DATE_COLUMN, type: 'default' };
            }
            const matchingField = ds6TableViewFieldsMap?.get(columnId);
            if (matchingField) return matchingField;
            const selectedColumn = selectedTableViewColumnsMap?.get(columnId);
            return {
              id: columnId,
              title: selectedColumn?.label || selectedColumn?.title || columnId,
              type: 'string'
            };
          })
          ?.filter(Boolean);
      } else {
        ds6OrderedTableColumns = [
          { id: DEFAULT_FORM_NUMBER_COLUMN, type: 'default' },
          ...ds6TableViewFields,
          { id: DEFAULT_CREATED_DATE_COLUMN, type: 'default' }
        ];
      }
    } else {
      ds6OrderedTableColumns = [
        { id: DEFAULT_FORM_NUMBER_COLUMN, type: 'default' },
        ...(dataSourceValueState?.[0]?.form_version__schema?.fields || [])
          .filter(field => field && !this.ignoreFields?.includes(this.getIgnoreFieldKey(field))),
        { id: DEFAULT_CREATED_DATE_COLUMN, type: 'default' }
      ];
    }
    const normalizeSearchValue = (rawValue) => {
      if (rawValue === null || rawValue === undefined) return '';
      if (typeof rawValue === 'string') return rawValue.toLowerCase();
      if (typeof rawValue === 'number' || typeof rawValue === 'boolean') return String(rawValue).toLowerCase();
      if (Array.isArray(rawValue)) {
        return rawValue
          .map(item => normalizeSearchValue(item))
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
      }
      if (typeof rawValue === 'object') {
        return Object.values(rawValue)
          .map(item => normalizeSearchValue(item))
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
      }
      return '';
    };
    const getDs6SearchableValues = (entry) => {
      if (!hasSelectedTableViewColumns) {
        return [
          normalizeSearchValue(entry?.name),
          ...Object.values(entry?.data || {}).map(value => normalizeSearchValue(value))
        ].filter(Boolean);
      }
      return selectedTableViewColumns?.map((columnId) => {
        if (columnId === DEFAULT_FORM_NUMBER_COLUMN) {
          const year = entry?.form_date ? moment(entry?.form_date)?.format('YY') : '';
          const formNumber = entry?.order_number ? String(entry?.order_number) : '';
          return normalizeSearchValue(year && formNumber ? `${year} - ${formNumber}` : formNumber);
        }
        if (columnId === DEFAULT_CREATED_DATE_COLUMN) {
          return normalizeSearchValue(renderInfoForType({ type: 'datetime' }, entry?.form_date, null, null, null, null, null, user));
        }
        return normalizeSearchValue(entry?.data?.[columnId]);
      }).filter(Boolean);
    };
    let fieldWidget;
    if (widget === 'dropdown' && dataSourceID === 'ds6') {
      fieldWidget = (
        <Select
          value={selectedValue}
          onChange={e => this.handleSelectChange(e, fieldId, false)}
          options={dropdownValues?.map(ele => ({
            key: ele?.key,
            label: ele?.value,
            value: ele?.value,
            detailKey: ele?.detailKey,
            data: ele?.data
          })) ?? []}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 99999 }),
            input: base => ({ ...base, ...(newStyles ? { margin: 0, padding: 0 } : {}) })
          }}
          menuPortalTarget={document.body}
          isDisabled={disabled || settings?.data_source_interaction_type?.value === 'createNewEntry'}
          className={`react-select-custom ${StylesClasses || ''}
          ${newStyles ? 'newStyles' : ''} ${!selectedValue && showFieldErrors && newStyles && isRequired ? 'error_border' : ''}`}
          classNamePrefix={newStyles ? 'customA' : 'custom'}
          placeholder={placeholder}
        />
      );
    } else if (widget === 'dropdown') {
      fieldWidget = (
        <select
          value={selectedValue}
          onChange={e => this.handleAnswerChanged(e.target.value, fieldId, e.target)}
          onBlur={this.handleCalValues}
          name={`select-field-${fieldId}`}
          className={`pulpo-dropdown ${!answer && showFieldErrors && isRequired && newStyles && 'error_border'}
                      ${newStyles ? 'newStyles' : ''}`}
          disabled={disabled}
          placeholder={placeholder}
        >
          <option key="default" value="">
            {defaultOption}
          </option>
          {dropdownValues?.map(option => (
            <option key={option.key} value={option.key}>
              {fullWidth && (option?.value?.length > 107 ? `${option.value.substring(0, 107)}...` : option.value)}
              {!fullWidth && (option?.value?.length > 40 ? `${option.value.substring(0, 40)}...` : option.value)}
            </option>
          ))}
        </select>
      );
    } else if (widget === 'multiSearch') {
      fieldWidget = (
        settings?.enable_multi_select_for_this_data_source_field
        ? (
        <>
          <div>
            <Select
              isMulti
              value={selectedValue}
              onChange={e => this.handleMultiAnswerChanged(e?.map(i => i?.value) ?? [], fieldId, e)}
              options={
                settings?.data_source_interaction_type?.value !== 'createNewEntry'
                ? dropdownValues?.map(ele => ({ key: ele?.detailKey, label: ele?.value, value: ele?.detailKey, detailKey: ele?.detailKey })) : []}
              styles={{
                menuPortal: base => ({ ...base, zIndex: 99999 }),
                input: base => ({ ...base, ...(newStyles ? { margin: 0, padding: 0 } : {}) })
              }}
              menuPortalTarget={document.body}
              isDisabled={disabled}
              className={`react-select-custom ${newStyles && selectedValue?.length >= 3 ? 'multi' : ''}
              ${selectedValue?.length === 0 && showFieldErrors && newStyles && isRequired ? 'error_border' : ''}
              ${newStyles ? 'newStyles' : ''} ${StylesClasses || ''}`}
              classNamePrefix={newStyles ? 'customA' : 'custom'}
            />
          </div>
          <div style={{ display: 'flex', marginLeft: '3px' }}>
            {dropdownValues?.length === answer?.length && dropdownValues?.length > 0
            && settings?.data_source_interaction_type?.value !== 'createNewEntry' && (
              <Clickable
                className={`${newStyles ? styles.detailsLink_new : ''} ${styles.detailsLink || ''}`}
                onClick={() => this.handleMultiAnswerChanged([], fieldId)}
              >
                <FormattedMessage
                  id="pulpofield.unselect.all"
                  defaultMessage="Clear Selection"
                  tagName="p"
                />
              </Clickable>
            )}
          </div>
        </>) : (
          <Select
            allowClear
            value={selectedValue ? { label: selectedValue, value: selectedValue } : null}
            onChange={e => this.handleAnswerChanged(e.value, fieldId, e)}
            styles={{
              menuPortal: base => ({ ...base, zIndex: 99999 }),
              input: base => ({ ...base, ...(newStyles ? { margin: 0, padding: 0 } : {}) }),
              control: base => ({
                ...base
              })
            }}
            isDisabled={disabled || settings?.data_source_interaction_type?.value === 'createNewEntry'}
            menuPortalTarget={dropdownMovesWithField ? null : document.body}
            options={dropdownValues}
            className={`react-select-custom ${StylesClasses || ''}
            ${newStyles ? 'newStyles' : ''} ${!selectedValue && showFieldErrors && newStyles && isRequired ? 'error_border' : ''}`}
            classNamePrefix={newStyles ? 'customA' : 'custom'}
            placeholder={placeholder}
          />)
      );
    } else if (widget === 'singleSearch') {
      fieldWidget = (
        <Dropdown
          selection
          search
          scrolling
          clearable
          value={selectedValue}
          options={[
            { key: '', value: '', text: '' },
            ...dropdownValues
          ]}
          onChange={(e, val) => this.handleAnswerChanged(val.value, fieldId, val)}
          className={`react-select-custom ${StylesClasses || ''}
            ${newStyles ? 'newStyles' : ''} ${!selectedValue && showFieldErrors && newStyles && isRequired ? 'error_border' : ''}`}
            classNamePrefix={newStyles ? 'customA' : 'custom'}
        />
      );
    } else if (widget === 'portal_user') {
      fieldWidget = (
        <Select
          isMulti
          value={answer}
          onChange={e => this.handleAnswerChanged(e, fieldId)}
          name={`select-field-${fieldId}`}
          className={`${StylesClasses || ''}`}
          options={(values || [])?.map(usr => ({
             label: (settings?.hide_company_name || isHideCompanyName) ? usr.value : `${usr.tenantName?.join?.(', ') || ''} - ${usr.value}`,
             key: usr.key,
             value: usr.value
          }))?.sort((a, b) => a.label.localeCompare(b.label))}
        />
      );
    } else if (widget === 'user_dropdown' || fieldType === 'user_dropdown') {
      fieldWidget = (
        <Select
          isMulti
          value={answer}
          onChange={e => this.handleAnswerChanged(e, fieldId)}
          name={`select-field-${fieldId}`}
          className={`${StylesClasses}`}
          placeholder={placeholder}
          options={selected_users?.map(usr => ({ label: usr.value, key: usr.key, value: usr.value }))}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 99999 })
          }}
          menuPortalTarget={document.body}
        />
      );
    } else {
      fieldWidget = (
        <div className={styles.pulpoRadio}>
          {dropdownValues?.map(option => (
            <label key={option.key}>
              <input
                type="radio"
                className="pulpo-radio"
                value={option.key}
                onChange={e => this.handleAnswerChanged(e.target.value, fieldId, e.target)
                }
                checked={selectedValue === option.key}
                disabled={disabled}
              />
              {option.value}
            </label>
          ))}
        </div>
      );
    }

    let inlineTable = null;
    if (dataSourceID === 'ds3' && settings?.show_values_in_inline_table_view) {
      const { ds3InlineViewMode } = this.state;
      const selectedKey = Array.isArray(selectedValue)
        ? selectedValue?.[0]?.detailId || selectedValue?.[0]?.value || selectedValue?.[0]
        : (selectedValue?.detailId || selectedValue?.value || selectedValue);
      const selectedKeyStr = selectedKey === null || selectedKey === undefined ? '' : String(selectedKey);
      const selectedEntry = this.findSelectedDs3Entry(
        dataSourceValueState,
        selectedKey,
        selectedKeyStr
      );
      if (selectedEntry && Array.isArray(source_fields) && source_fields.length > 0) {
        inlineTable = (
          <>
            {ds3InlineViewMode === 'grid' ? (
              <div className={styles.inlineGridContainer}>
                <div className={styles.ds3InlineGrid}>
                  {source_fields?.map((col) => {
                    const fieldKey = col?.id ?? col?.value ?? col?.key ?? col?.name;
                    const label = col?.title || col?.name || col?.label || fieldKey;
                    const value = fieldKey ? this.getDataSourceFieldValue(selectedEntry, fieldKey) : '';
                    const rawValue = value ?? '';
                    const displayValue = String(rawValue).trim() === '' ? '' : String(rawValue);
                    const inputClassName = `pulpo-charfield ${newStyles ? 'newStyles' : ''} ${styles.ds3InlineInput}`;

                    return (
                      <div
                        key={fieldKey || col?.title || col?.name}
                        className={styles.ds3InlineCell}
                      >
                        <span className={styles.ds3InlineLabel}>{label}</span>
                        <input
                          className={inputClassName}
                          value={displayValue}
                          disabled
                          readOnly
                          aria-label={label}
                          title={rawValue}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className={`${styles.inlineGridContainer} ${styles.inlineGridContainerList}`}>
                <div className={`${styles.inlineTable}`}>
                  <table className={`${styles.inlineTableTable}`}>
                    <thead>
                      <tr>
                        {source_fields?.map((col) => {
                          const fieldKey = col?.id ?? col?.value ?? col?.key ?? col?.name;
                          const label = col?.title || col?.name || col?.label || fieldKey;
                          return (
                            <th key={fieldKey || label}>
                              {label}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {source_fields?.map((col) => {
                          const fieldKey = col?.id ?? col?.value ?? col?.key ?? col?.name;
                          const value = fieldKey ? this.getDataSourceFieldValue(selectedEntry, fieldKey) : '';
                          const rawValue = value ?? '';
                          const displayValue = String(rawValue).trim() === '' ? '-' : String(rawValue);
                          return (
                            <td key={fieldKey || col?.title || col?.name} title={rawValue}>
                              {displayValue}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        );
      }
  }

    const inlineTableNode = inlineTable
      ? (
        <div className={`${styles.assetRegistryInlineWrapper} ${(forFormModule) ? styles.assetRegistryInlineWrapperFormsFix : ''}`}>
          {inlineTable}
        </div>
      )
      : null;

    return (
      <>
        {!newStyles && (dataSourceID === 'ds3' && settings?.show_values_in_inline_table_view
          ? (
            <div className={styles.fieldWidget}>
              {fieldWidget}
            </div>
          )
          : fieldWidget)}
        {!newStyles && inlineTableNode}
        {dataSourceID === 'ds6' && (
          <FormDataSourceDetails
            key={fieldId}
            newStyles={newStyles}
            link={!fromMultiGrid && showLinkedValuesInline}
            search={!disableDataSourceActions && filters?.show_values?.value === 'table' && !fromMultiGrid}
            createNew={!disableDataSourceActions && settings?.data_source_interaction_type?.value === 'createNewEntry'}
            showInLineTable={showLinkedValuesInline}
            FormDetailID={this.getFormDetailID({ formEntryAnswer, settings, answer })}
            handleSearchModal={this.handleSearchModal}
            fieldId={fieldId}
            isExceed={isExceed}
            count={settings?.restricted_count_for_multiSelect}
            serachModal={serachModal}
            handleCreateFormModal={this.handleCompleteFormModal}
            stepId={useCurrentStep?.id}
            answer={answer}
            settings={settings}
            autoFetch={showLinkedValuesInline && (formDetail || edit)}
            formDetails={formDetail || edit}
            dataSourceID={dataSourceID}
            filters={filters}
            dataSourceValueState={dataSourceValueState}
            handleAnswerForTableSelect={(...args) => this.handleSelectChange(...args)}
            ds6OrderedTableColumns={ds6OrderedTableColumns}
            getDs6SearchableValues={getDs6SearchableValues}
            renderDs6PreviewColumnValue={this.renderDs6PreviewColumnValue}
            getDs6EntrySchema={getDs6EntrySchema}
            ds6TableViewFields={ds6TableViewFields}
          />
        )}
        {newStyles && (dataSourceID === 'ds3' && settings?.show_values_in_inline_table_view
          ? (
            <div className={isInspection ? styles.fieldWidget : styles.fieldWidgetNew}>
              {fieldWidget}
            </div>
          )
          : fieldWidget)}
        {newStyles && inlineTableNode}
        {formCreateModal && (
          <Modal
            width={window.screen.width > 1600 && newStyles ? '85%' : '943px'}
            showIn={formCreateModal}
            onClose={() => this.handleCompleteFormModal(false, 'clearCreate')}
            contentStyles={{
              width: window.screen.width > 1600 && newStyles ? '85%' : '943px',
              maxHeight: '90%',
              scrollbarWidth: 'thin',
              overflowY: 'scroll'
            }}
          >
            <div>
              <div className={styles.title}>
                {filters?.form_name}
                <Clickable
                  onClick={() => this.handleCompleteFormModal(false, 'clearCreate')}
                  className={styles.closeIcon}
                >
                  <img src={closeIcon} alt="X" />
                </Clickable>
              </div>
              <CompleteForm
                formId={filters.form_key}
                filters={filters}
                formDataEntry
                editForm
                handleFormModal={this.handleCompleteFormModal}
              />
            </div>
          </Modal>
        )}
    {(dataSourceID === 'ds14' || dataSourceID === 'ds5') && source_fields?.length > 0 && answer
        && <div>
              <DataSourceInformation
              sourceFields={source_fields}
              dataSourceValues={dataSourceValueState}
              answer={answer}
              handleValueChange={handleValueChange}
              fieldId={fieldId}
               />
           </div>}
      </>
    );
  }
}

DataSource.defaultProps = {
  widget: { type: 'dropdown' },
  answer: '',
  defaultOption: '',
  disableDataSourceActions: false
};

DataSource.propTypes = {
  widget: PropTypes.shape({ type: PropTypes.string }),
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  defaultOption: PropTypes.string,
  forFormModule: PropTypes.bool,
  isInspection: PropTypes.bool,
  disableDataSourceActions: PropTypes.bool,
  actionClearFetchedForm: PropTypes.func,
  actionFetchLinkedForms: PropTypes.func
};

const mapStateToProps = state => ({
  publishFormAction: state.forms.action,
  createAction: state.forms.createFormAnswerAction,
  createdFormAnswer: state.forms.createdFormAnswer,
  fetchAnswerAction: state.forms.fetchAnswerAction,
  allDataSources: state.inspection.allDataSources || [],
  user: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionClearFetchedForm: () => dispatch(actionClearForm()),
  actionFetchLinkedForms: id => dispatch(fetchDataSourceFormDetails(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(DataSource);
